<template>
    <ul class="nav justify-content-center pt-4 pb-5 profile-nav">
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'account.profile.personal-information' }">
                <div class="nav-img">
                    <img v-if="user === 'M'" :src="male" class="img-fluid" alt="">
                    <img v-else :src="female" class="img-fluid" alt="">
                </div>
                Personal <span class="hide">Information</span> 
            </router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'dashboard' }">
                <div class="nav-img">
                    <img :src="back" class="img-fluid" alt="">
                </div>
                Back<span class="hide"> to Dashboard</span>
            </router-link>
        </li>
    </ul>
</template>

<style scoped>
	.profile-nav .nav-item {
		margin: 0px 20px;
	}

	.profile-nav .nav-item .nav-link {
		text-align: center;
	}

	.profile-nav .nav-img {
		width: 40px;
		margin: auto;
		margin-bottom: 10px;
	}

	@media (max-width: 425px) {
		.nav-link {
			display: block;
			padding: 0.5rem 0.8rem;
		}

		.profile-nav .nav-item {
			margin: 0px 3px;
		}

		.profile-nav .nav-img {
			width: 30px;
			margin-bottom: 10px;
		}

		.hide {
			display: none;
		}
	}
</style>

<script>
import male from '../../../../../../img/male.svg'
import female from '../../../../../../img/female.svg'
import back from '../../../../../../img/return.svg'

	export default {
		data() {
			return {
				male, 
				female,
				back,
				user: this.$store.getters.user.client.gender,
			};
		},
	};
</script>